import { useWindow } from '@krp/client-runtime'
import { NativeReceiptDetail, receiptsNativeDetail } from '@krp/resource-receipts-ui'
import { StatusMessage } from '@krp/ui-kit'
import { errorText } from './reportHooks'

/** Собственный чек по кассе и номеру — содержимое окна чека поверх экрана. */
export function OwnReceiptDetailView({ resourceId, id }: { resourceId: string; id: string }) {
  const detail = receiptsNativeDetail.useQuery({ resourceId, id })
  if (detail.isError) return <StatusMessage kind="error" title="Не удалось получить чек" text={errorText(detail.error) ?? ''} />
  if (detail.currentData === undefined) return <StatusMessage kind="loading" title="Загружаем чек…" />
  return <NativeReceiptDetail receipt={detail.currentData} />
}

export function OwnReceiptDetailBinding() {
  const window = useWindow()
  return <OwnReceiptDetailView resourceId={window.params.rid ?? ''} id={window.params.id ?? ''} />
}
